/**
 * @generated SignedSource<<7b29a85fe263af61bc2ce1986c370fa1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row671BadPattern$data = {
  readonly node: {
    readonly id: string;
    readonly isHighlightedIssueRow: boolean | null | undefined;
    readonly issueId: string;
    readonly " $fragmentSpreads": FragmentRefs<"BeforeFirstCell">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow16BadPattern">;
  readonly " $fragmentType": "Row671BadPattern";
};
export type Row671BadPattern$key = {
  readonly " $data"?: Row671BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row671BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isReparentingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "Row671BadPattern",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "projectKeys",
          "variableName": "projectKeys"
        },
        {
          "kind": "Variable",
          "name": "shouldQueryHasChildren",
          "variableName": "shouldQueryHasChildren"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueRow16BadPattern"
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "issueId"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isReparentingEnabled",
              "variableName": "isReparentingEnabled"
            }
          ],
          "kind": "FragmentSpread",
          "name": "BeforeFirstCell"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isHighlightedIssueRow"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueEdge"
};

(node as any).hash = "c7078d64e4849331efdbeca9570755df";

export default node;
